import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { Tooltip } from "@material-ui/core";
import { AvatarIconComponent } from "../../components/icon_components";

const styles = theme => ({
    title: {
        paddingLeft: '80px',
        paddingRight: '80px',
        paddingTop: '35px',
    },
    card: {
        marginTop: "10px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
    background: "#fff",
    ":hover": {
      background: "#BBDEFB"
    }
    },
    cardHover: {
        marginTop: "30px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#AAA"
    },
    cardAvatar: {
        maxWidth: "130px",
        maxHeight: "130px",
        borderRadius: "50%",
        overflow: "hidden",
        boxShadow:
            "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },

    textAlign: {
        textAlign: "center"
    },
    cardSubtitle: {
        color: "#999",
        fontSize: "1em",
        textTransform: "uppercase",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardTitle: {
        fontSize: "1.3em",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardDescription: {
        padding: "5px 10px"
    },
    cardActions: {
        height: "auto",
        display: "inline"
  },
  bigAvatar: {
    width: 80,
    height: 80
  }
});

class Kid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            deleteStatus: false,
            deleteError: false,
            redirect: false,
            updateRequest: false,
            bgColor: '#FFF'
        };
    }

    cardHovering = () => {
        this.setState({ bgColor: '#BBDEFB' });
    };

    cardNormal = () => {
        this.setState({ bgColor: '#FFF' });
    };

  render() {
    const { classes, backgroundColor } = this.props;

    var { firstName, lastName, gender, saveDate } = this.props.data;
    const accountId = this.props.id;

        var updateId = "/kids/details/" + this.props.id;

        if (this.state.redirect) {
            return (
                <Redirect to='/sudo/kids' />
            );
        }

        if (this.state.updateRequest) {
            return (
                <Redirect to={updateId} />
            );
        }

        return (
            <Tooltip title='Click to update or view details'>
                <Card style={{ background: this.state.bgColor }} onMouseOver={this.cardHovering} onMouseLeave={this.cardNormal} onClick={() => this.setState({ updateRequest: true })} className={classes.card} >
                    <CardContent>
                        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid
                alignContent="center"
                item
                xs={12}
                sm={3}
                md={2}
                lg={2}
                xl={2}
              >
                <AvatarIconComponent
                  backgroundColor={backgroundColor}
                  colorSet={true}
                  className={classes.bigAvatar}
                >
                  <div style={{ textTransform: "uppercase" }}>
                    {firstName.substring(0, 1) + lastName.substring(0, 1)}
                  </div>
                </AvatarIconComponent>
              </Grid>
              <Grid
                spacing={0}
                container
                item
                xs={12}
                sm={9}
                md={10}
                lg={10}
                xl={10}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <Typography
                    variant="title"
                    className={classes.cardDescription}
                  >
                    {firstName + " " + lastName}
                  </Typography>
                  <Typography component="p" className={classes.cardDescription}>
                    {accountId}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <Typography component="p" className={classes.cardDescription}>
                    {gender}
                  </Typography>
                  <Typography component="p" className={classes.cardDescription}>
                    Saved at {saveDate}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Tooltip>
    );
  }
}

Kid.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Kid);



// WEBPACK FOOTER //
// ./src/components/Kids/Kid.js